import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@shared-utils/ui";

const inputVariants = cva(
  "shadow-xs focus-visible:outline-hidden flex w-full rounded-md border border-input bg-background transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-ter-gray-400 focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      inputSize: {
        default: "h-8 px-3 py-1 text-[16px] md:text-sm",
        lg: "h-10 px-4 py-2 text-lg",
      },
    },
    defaultVariants: {
      inputSize: "default",
    },
  },
);

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof inputVariants>;

const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { className, type, inputSize = "default", ...rest } = props;
  return (
    <input
      type={type}
      className={cn(
        inputVariants({ inputSize }),
        type === "date" && "dark:[color-scheme:dark]",
        className,
      )}
      ref={ref}
      {...rest}
    />
  );
});
Input.displayName = "Input";

export { Input, inputVariants };
